import angular from 'angular';
import digits from './digits';
import fymStatus from './fym-status/fym-status';
import inflector from './inflector/inflector';
import hyphenInflector from './hyphen-inflector/hyphen-inflector';
import dateFnsFormat from './date-fns-format';
import newlineToBr from './newline-to-br/newline-to-br';
import phoneNumber from './phone-number/phone-number';
import result from './result/result';
import titleize from './titleize';
import unsafe from './unsafe/unsafe';
import zip from './zip-code/zip-code';

export default angular.module('app.filters', [
  digits.name,
  fymStatus.name,
  inflector.name,
  hyphenInflector.name,
  dateFnsFormat.name,
  newlineToBr.name,
  phoneNumber.name,
  result.name,
  titleize.name,
  unsafe.name,
  zip.name,
]);
